import { createReducer } from '@reduxjs/toolkit';
import VideoStatus from 'enums/VideoStatus';
import omitBy from 'lodash/omitBy';
import { actionManager, buildActionStatus } from '../utils';
import * as va from './videoActions';

const initialState = {
  isSharingContent: false,
  contentSharerId: null,
  muted: false,
  videoStatus: VideoStatus.Disabled,
  guestSpeakerId: null,
  startAudio: false,
  showCaptions: false,
  localTileId: null,
  tileMap: {},
  contentTile: null,
  canUnmute: true,
  actionStatus: buildActionStatus(va),
};

const videoReducer = createReducer(initialState, {
  [va.initAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: true, error: '' }),
  [va.successAction]: (state, { payload: { key } }) =>
    actionManager(state, key, { loading: false, error: '' }),
  [va.errorAction]: (state, { payload: { key, error } }) =>
    actionManager(state, key, { loading: false, error }),
  [va.startContentShareAction]: (state, { payload }) => ({
    ...state,
    isSharingContent: true,
    contentSharerId: payload.attendeeId,
  }),
  [va.resetStateAction]: () => ({
    ...initialState,
  }),
  [va.stopContentShareAction]: (state) => ({
    ...state,
    isSharingContent: true,
    contentSharerId: null,
  }),
  [va.setMutedAction]: (state, { payload }) => ({ ...state, muted: payload }),
  [va.toggleVideoStatusAction]: (state, { payload }) => ({
    ...state,
    videoStatus: payload,
  }),
  [va.setGuestSpeakerIdAction]: (state, { payload }) => ({
    ...state,
    guestSpeakerId: payload,
  }),
  [va.toggleCaptionsAction]: (state) => ({
    ...state,
    showCaptions: !state.showCaptions,
  }),
  [va.setLocalTileAction]: (state, { payload: { tileId } }) => {
    return {
      ...state,
      localTileId: tileId,
    };
  },
  [va.setContentTileAction]: (state, { payload }) => ({
    ...state,
    contentTile: payload,
  }),
  [va.setCanUnmuteAction]: (state, { payload: canUnmute }) => ({
    ...state,
    canUnmute: canUnmute,
  }),
  [va.setTileAction]: (state, { payload: { tileId, attendeeId } }) => {
    return {
      ...state,
      tileMap: { ...state.tileMap, [attendeeId]: tileId },
    };
  },
  [va.removeTileAction]: (state, { payload: { tileId } }) => ({
    ...state,
    tileMap: omitBy(state.tileMap, (value) => value === tileId),
  }),
});

export default videoReducer;
